import React, { useEffect, useReducer, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showSnack } from 'react-redux-snackbar';

import AssetsTable from '../../components/AssetsTAble';
import { FilterAssets } from '../../components/FilterAssets';
import FooterDashboard from '../../components/FooterDashboard';
import HeaderComponent from '../../components/Header';
import useDebounce from '../../hooks/useDebounce';
import searchReducer from '../../redux/searchReducer';
import { getApi } from '../../services/api';
import AssetsTopHeader from '../IncidentsScreen/AssetsTopHeader';
import './index.css';
import { fetchFilterData, showFilterData } from '../../components/FilterAssets/fetchFilterData';
import { ShowFilterView } from '../../components/FilterAssets/ShowFilterView';
import { addExtraColums } from '../../redux/addExtraColums';
import { escapeRegExp } from '../../utils/sanitizeFileName';
import { useLocation, useNavigate } from 'react-router-dom';
import { allowedMethods } from '../../components/FilterAssets';
import { filterValues } from '../../components/FilterAssets';

const [EQUAL_TO] = allowedMethods;

const AssetsManagment = function () {
	const [openModal, setModalState] = useState(false);
	const [state, searchDispatch] = useReducer(searchReducer, {
		isSearched: false,
		searchText: '',
		searchAssets: [],
		filterInfo: [],
		pagination: {
			pageNumber: 1,
			limit: 10,
			total: 0,
		},
		searchWithFilterText: null,
	});
	const navigate = useNavigate();
	const location = useLocation();
	const [filterSelected, selectedNewFilter] = useState(null);
	const debouncedSearchTerm = useDebounce(state.searchText, 500);
	const filterText = escapeRegExp(debouncedSearchTerm);
	const dispatch = useDispatch();
	const { state: routeState } = useLocation();
	const queryParams = new URLSearchParams(location.search);
	const allParams = {};


	useEffect(() => {
		if (routeState?.filter.length > 0) {
			for (let i = 0; i < routeState.filter.length; i++) {
				const filterfound = filterValues.find((el) => el.name === routeState.filter[i].name);
				console.log(filterfound);

				if (filterfound) {
					onAdd({
						...filterfound,
						value: routeState.filter[i].value,
					});
				}
			}
		}
	}, [routeState]);

	useEffect(() => {
		console.log(routeState?.filter.length, 'routeState?.filter.length', routeState);
		if (!routeState) {
			console.log('routeState.filter123');
			saveFilterInfo(state.filterInfo, state.pagination.pageNumber);
		}
	}, [routeState]);

	for (let [key, value] of queryParams.entries()) {
		const values = value.split(',');

		if (allParams[key]) {
			allParams[key] = Array.isArray(allParams[key])
				? [...allParams[key], ...values]
				: [allParams[key], ...values];
		} else {
			allParams[key] = values;
		}
	}

	useEffect(() => {
		for (let i in allParams) {
			const filter = filterValues.find((el) => el.name === i);
			onAdd({
				value: allParams[i],
				method: EQUAL_TO,
				label: filter ? filter.label : i,
				name: i,
				type: 'text',
			});
		}
	}, []);

	useEffect(() => {
		console.log('saveFilterInfo(allFilterInfo);');
		if (Object.keys(allParams).length > 0 || routeState?.filter) {
			saveFilterInfo(state.filterInfo);
		}
	}, [state.filterInfo]);

	const onFilterTextChange = async (e) => {
		try {
			console.log(state.filterInfo, e.target.value);
			if ((state.filterInfo && state.filterInfo.length > 0) || true) {
				searchDispatch({ type: 'updatedSearchText', payload: e.target.value });
				searchDispatch({ type: 'inputSearchedWithFilter', payload: e.target.value });
				const { assetList, totalAssets } = await showFilterData(
					state.filterInfo,
					dispatch,
					'show',
					e.target.value,
					1,
					state.pagination.limit
				);

				console.log(assetList, totalAssets, 'assetList, totalAssets');
				if (assetList && assetList.length > 0) {
					searchDispatch({ type: 'setPageNumber', payload: 1 });
					searchDispatch({ type: 'saveSearchResult', payload: assetList });
					searchDispatch({ type: 'setTotalSearchAssets', payload: totalAssets });
					searchDispatch({ type: 'inputSearchedWithFilter', payload: e.target.value });
					setModalState(false);
				}
			} else {
				searchDispatch({ type: 'inputSearchedWithFilter', payload: null });
				searchDispatch({ type: 'updatedSearchText', payload: e.target.value });
			}
		} catch (e) {
			console.error(e);
		}
	};

	const removeAsset = (assetId) => {
		searchDispatch({ type: 'removeAsset', payload: assetId });
	};

	const onAdd = (filterData) => {
		searchDispatch({ type: 'saveFilterInfo', payload: [{ ...filterData, id: Date.now() }] });
		selectedNewFilter(null);
	}
	const saveFilterInfo = async (filterInfo = state.filterInfo, pageNumber, limit) => {
		console.log('savefilterinfo 1212', filterInfo);

		const { assetList, totalAssets } = await showFilterData(
			filterInfo,
			dispatch,
			'show',
			state.searchWithFilterText,
			pageNumber,
			limit
		);
		if (assetList && assetList.length > 0) {
			searchDispatch({ type: 'saveSearchResult', payload: assetList });
			searchDispatch({ type: 'setTotalSearchAssets', payload: totalAssets });
			setModalState(false);
			navigate(location.pathname, { replace: true });
		} else {
			searchDispatch({ type: 'saveSearchResult', payload: [] });
		}
	};

	const updateSearchPageNumber = (pagination) => {
		console.log('updateSearchPageNumber', pagination);
		searchDispatch({ type: 'setPageNumber', payload: pagination.current });
		searchDispatch({ type: 'setLimitInPage', payload: pagination.pageSize });
		saveFilterInfo(state.filterInfo, pagination.current, pagination.pageSize);
	};

	const deleteFilter = () => {
		console.log('deleteFilter');
	};

	return (
		<>
			<div className="dashboard-container">
				<HeaderComponent />
				<AssetsTopHeader />
				<FilterAssets
					openModal={openModal}
					onAdd={onAdd}
					filterSelected={filterSelected}
					selectedNewFilter={selectedNewFilter}
					setModalState={setModalState}
					searchDispatch={searchDispatch}
					allFilterInfo={state.filterInfo}
					saveFilterInfo={saveFilterInfo}
					searchText={state.searchText}
					onFilterTextChange={onFilterTextChange}
					filterView={
						<ShowFilterView
							extraClass={'dashboard-filter'}
							allFilterInfo={state.filterInfo}
							deleteFilter={deleteFilter}
							openModal={openModal}
							setModalState={setModalState}
						/>
					}
				/>
				<AssetsTable
					searchAssets={state.searchAssets}
					removeAssetInSearch={removeAsset}
					filterText={filterText}
					searchDispatch={searchDispatch}
					searchPagination={state.pagination}
					updateSearchPageNumber={updateSearchPageNumber}
				/>
				<FooterDashboard />
			</div>
		</>
	);
};

export default AssetsManagment;
